module.exports = __webpack_public_path__ + "build/img/NEUTRAL.0421c634.svg";